(function () {
  var dialog = document.getElementById('WaitingListPopup');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  if (dialog.parentElement !== document.body) {
    document.body.appendChild(dialog);
  }

  var previousOverflow = '';

  function openPopup() {
    if (!dialog.isConnected || dialog.open) return;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    if (dialog.open) dialog.close();
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-waiting-list-open]')) {
      event.preventDefault();
      openPopup();
      return;
    }

    if (event.target.closest('[data-waiting-list-close]')) {
      closePopup();
      return;
    }

    if (event.target === dialog) {
      var rect = dialog.getBoundingClientRect();
      var inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) closePopup();
    }
  });

  dialog.addEventListener('close', function () {
    document.body.style.overflow = previousOverflow;
  });

  if (dialog.dataset.state === 'success' || dialog.dataset.state === 'error') {
    openPopup();
    var url = new URL(window.location.href);
    if (url.searchParams.has('contact_posted')) {
      url.searchParams.delete('contact_posted');
      window.history.replaceState(null, '', url.toString());
    }
  }
})();